import { Avatar, Grid, List, ListItem, ListItemAvatar, ListItemText, Table, TableBody, TableCell, TableContainer, TableRow, Typography, useTheme } from "@mui/material";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

export const Legende = ({data}) => {
  const theme = useTheme();
  const {t} = useTranslation()

  const legendeStyles2 = useCallback(
    (color, antrag) => {
      if (antrag === "J") {
        switch (color) {
          case "weekend":
            return {
              backgroundColor: theme.palette.background.dim,
            };
          default:
            return {
              backgroundColor: theme.palette.background.dark,
            };
        }
      } else {
        switch (color) {
          case "primary":
            return {
              backgroundColor: theme.palette.primary.main,
            };
          case "weekend":
            return {
              backgroundColor: theme.palette.background.dim,
            };
          case "secondary":
            return {
              backgroundColor: theme.palette.secondary.light,
            };
          case "warning":
            return {
              backgroundColor: theme.palette.warning.main,
            };
          case "success":
            return {
              backgroundColor: theme.palette.success.main,
            };
          case "error":
            return {
              backgroundColor: theme.palette.error.main,
            };
          case "info":
            return {
              backgroundColor: theme.palette.info.main,
            };
          case "danger":
            return {
              backgroundColor: theme.palette.error.main,
            };
          case "default":
            return {
              backgroundColor: theme.palette.background.dark,
            };
          default:
            return {
              backgroundColor: theme.palette.background.dark,
            };
        }
      }
    },
    [theme]
  );

  const legendeStyles = useCallback(
    (red, green, blue, antrag) => {
      var tmpstyle = null;
      if (antrag === "J") {
        tmpstyle = {
          borderBottom: "4px solid " + setColor(red, green, blue, "1"),
          borderTop: "4px solid " + setColor(red, green, blue, "1"),
          backgroundColor: setColor(red, green, blue, ".1"),
        };
      } else {
        tmpstyle = {
          backgroundColor: `rgba(${red},${green},${blue},1)`,
          color: `rgba(${"000"},${"000"},${"000"},1)`,
        };
      }
      return tmpstyle;
    },
    [theme]
  );
  console.log(data);

  return (
    <Grid container>
      <Grid item xs={12}>
        <List>
        {data.map((obj, count) => {
          const style = obj.red
            ? legendeStyles(obj.red, obj.green, obj.blue)
            : legendeStyles2(obj.style);
          return (
            <ListItem key={count.toString()}>
            <ListItemAvatar><Avatar style={style}>{obj.key}</Avatar></ListItemAvatar>
            <ListItemText>{obj.bez}</ListItemText>
            </ListItem>
          );
        })
      }
        </List>
      </Grid>
    </Grid>
  );
};
